import countries from 'i18n-iso-countries'

// Import and register locales
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'
import da from 'i18n-iso-countries/langs/da.json'
import sv from 'i18n-iso-countries/langs/sv.json'
import nb from 'i18n-iso-countries/langs/nb.json'
import nl from 'i18n-iso-countries/langs/nl.json'
import fr from 'i18n-iso-countries/langs/fr.json'
import it from 'i18n-iso-countries/langs/it.json'
import es from 'i18n-iso-countries/langs/es.json'

countries.registerLocale(en)
countries.registerLocale(de)
countries.registerLocale(da)
countries.registerLocale(sv)
countries.registerLocale(nb)
countries.registerLocale(nl)
countries.registerLocale(fr)
countries.registerLocale(it)
countries.registerLocale(es)

const fallbackLang = 'en'

export type Country = {
  country: string
  countryCode: string
}

// Supported countries (original English names are fallback only)
export const ALL_COUNTRIES_WE_SUPPORT = [
  { country: 'Albania', countryCode: 'AL' },
  { country: 'Andorra', countryCode: 'AD' },
  { country: 'Australia', countryCode: 'AU' },
  { country: 'Belgium', countryCode: 'BE' },
  { country: 'Bosnia and Herzegovina', countryCode: 'BA' },
  { country: 'Bulgaria', countryCode: 'BG' },
  { country: 'Cyprus', countryCode: 'CY' },
  { country: 'Denmark', countryCode: 'DK' },
  { country: 'Estonia', countryCode: 'EE' },
  { country: 'Finland', countryCode: 'FI' },
  { country: 'France', countryCode: 'FR' },
  { country: 'Faroe Islands', countryCode: 'FO' },
  { country: 'Georgia', countryCode: 'GE' },
  { country: 'Gibraltar', countryCode: 'GI' },
  { country: 'Greece', countryCode: 'GR' },
  { country: 'Guernsey', countryCode: 'GG' },
  { country: 'Ireland', countryCode: 'IE' },
  { country: 'Iceland', countryCode: 'IS' },
  { country: 'Isle of Man', countryCode: 'IM' },
  { country: 'Italy', countryCode: 'IT' },
  { country: 'Canada', countryCode: 'CA' },
  { country: 'Kosovo', countryCode: 'XK' },
  { country: 'Croatia', countryCode: 'HR' },
  { country: 'Latvia', countryCode: 'LV' },
  { country: 'Liechtenstein', countryCode: 'LI' },
  { country: 'Lithuania', countryCode: 'LT' },
  { country: 'Luxembourg', countryCode: 'LU' },
  { country: 'Malta', countryCode: 'MT' },
  { country: 'Republic of Moldova', countryCode: 'MD' },
  { country: 'Monaco', countryCode: 'MC' },
  { country: 'Montenegro', countryCode: 'ME' },
  { country: 'Netherlands', countryCode: 'NL' },
  { country: 'The Republic of North Macedonia', countryCode: 'MK' },
  { country: 'Norway', countryCode: 'NO' },
  { country: 'New Zealand', countryCode: 'NZ' },
  { country: 'Poland', countryCode: 'PL' },
  { country: 'Portugal', countryCode: 'PT' },
  { country: 'Romania', countryCode: 'RO' },
  { country: 'San Marino', countryCode: 'SM' },
  { country: 'Switzerland', countryCode: 'CH' },
  { country: 'Serbia', countryCode: 'RS' },
  { country: 'Slovakia', countryCode: 'SK' },
  { country: 'Slovenia', countryCode: 'SI' },
  { country: 'Spain', countryCode: 'ES' },
  { country: 'United Kingdom', countryCode: 'GB' },
  { country: 'Sweden', countryCode: 'SE' },
  { country: 'Czech Republic', countryCode: 'CZ' },
  { country: 'Türkiye', countryCode: 'TR' },
  { country: 'Germany', countryCode: 'DE' },
  { country: 'Hungary', countryCode: 'HU' },
  { country: 'United States of America', countryCode: 'US' },
  { country: 'Holy See (Vatican City State)', countryCode: 'VA' },
  { country: 'Åland Islands', countryCode: 'AX' },
  { country: 'Austria', countryCode: 'AT' },
]

function normalizeLocale(locale: string): string {
  if (!locale) {
    return fallbackLang
  }
  return locale.split('-')[0].toLowerCase()
}

export function getCountryName(code: string, locale: string): string {
  const lang = normalizeLocale(locale)
  return countries.getName(code, lang) || countries.getName(code, fallbackLang) || code
}

export function getSupportedCountries(locale: string): Country[] {
  return ALL_COUNTRIES_WE_SUPPORT.map(({ countryCode }) => ({
    country: getCountryName(countryCode, locale),
    countryCode,
  }))
}
